/*
 * @Descripttion: mxgraph 编辑器封装
 * @Author: zenghua.wang
 * @Date: 2021-06-28 14:29:39
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-02 17:23:12
 */
import {
  MxEvent,
  MxClient,
  MxEditor,
  MxConstants,
  MxUtils,
  MxCodec,
  MxKeyHandler,
  MxGraphHandler,
  MxCellHighlight
} from '@/apisManage/mxgraph'
import Xml2Json from '@/apisManage/mxgraph/xml2json.js'

// apis编辑器
export function ApisEditor(options) {
  this.options = {
    el: null,
    bars: [],
    shapes: [],
    selectedCellListener: function() {}
  }
  Object.assign(this.options, options || {}, true)
  this.selectedCellListener = this.options.selectedCellListener
  var self = this

  // console.log("options==", this.options);
  if (MxClient.isBrowserSupported()) {
    this.editor = new MxEditor()
    this.editor.setGraphContainer(this.options.el)

    this.graph = this.editor.graph
    this.graph.setConnectable(true) // 允许连线
    this.graph.setCellsEditable(false) // 不可修改
    // this.graph.setCellsResizable(false); // 禁止改变元素大小
    // this.graph.setMultigraph(false) // 禁止重复连接
    // this.graph.setAllowLoops(true) // 允许自己连自己
    // this.graph.isHtmlLabel = function (cell) {
    //   return !this.isSwimlane(cell)
    // }
    this.graph.setTooltips(false)
    // value 转换为title
    this.graph.convertValueToString = (cell) => {
      return cell.title
    }
    // 启用对齐线帮助定位
    MxGraphHandler.prototype.guidesEnabled = true

    // 初始化toolbar
    this.init()

    // 配置样式
    this.configureStylesheet()

    // 高亮显示
    this.highlight()

    // 事件监听
    // var pasteCount = 0
    // mxEvent.addListener(this.options.el, 'paste', function (e) {
    //   var pasteText = e.clipboardData.getData('Text')
    //   var doc = mxUtils.parseXml(pasteText)
    //   if (doc) {
    //     var root = doc.documentElement
    //     var dec = new mxCodec(root.ownerDocument)
    //     var cells = dec.decode(root)
    //     if (cells && cells.length > 0) {
    //       pasteCount++
    //       self.graph.setSelectionCells(self.graph.importCells(cells, pasteCount * 10, pasteCount * 10, self.graph.getDefaultParent()))
    //     } else {
    //       this.execute('paste')
    //     }
    //   } else {
    //     self.execute('paste')
    //   }
    // })

    this.keyHandler = new MxKeyHandler(this.graph)
    this.keyHandler.getFunction = function(evt) {
      if (evt != null) {
        return MxEvent.isControlDown(evt) || (MxClient.IS_MAC && evt.metaKey)
          ? this.controlKeys[evt.keyCode]
          : this.normalKeys[evt.keyCode]
      }
      return null
    }
    // this.bindKeyAction()

    // 选择节点事件
    // this.graph.getSelectionModel().addListener(mxEvent.CHANGE, function (sender, evt) {
    //   self.onSelectedCell(sender, evt);
    // })

    // 双击事件
    this.graph.addListener(MxEvent.DOUBLE_CLICK, function(sender, evt) {
      self.onSelectedCell(sender, evt)
    })
  } else {
    console.error('浏览器不支持')
  }
}

// toolbar 初始化
ApisEditor.prototype.init = function() {
  var self = this

  if (this.options.bars.length <= 0 || this.options.shapes.length <= 0) {
    return
  }

  this.options.shapes.forEach((item, index) => {
    var { width, height, title, name, data, value, style, defaultAdd } = item
    var dom = self.options.bars[index]

    var dropHandler = (graph, evt, cell, x, y) => {
      var parent = self.graph.getDefaultParent()
      var styles = Object.keys(style)
        .map((attr) => `${attr}=${style[attr]}`)
        .join(';')

      self.graph.getModel().beginUpdate()
      try {
        var vertex = self.graph.insertVertex(
          parent,
          self.setId(value),
          value,
          x,
          y,
          width,
          height,
          styles
        )
        vertex.title = title
        vertex.name = name
        // vertex.prop = self.setId(value)
        vertex.data = data
        vertex.index = self.getIndex(value)
        vertex.createTime = Date.now()
      } finally {
        self.graph.getModel().endUpdate()
      }
      self.graph.setSelectionCell(cell)
    }

    var createDragPreview = () => {
      var elt = document.createElement('div')
      elt.style.border = '2px dotted red'
      elt.style.width = `${width}px`
      elt.style.height = `${height}px`
      return elt
    }

    var ds = MxUtils.makeDraggable(
      dom,
      this.graph,
      dropHandler,
      createDragPreview(),
      0,
      0,
      true,
      true
    )
    ds.setGuidesEnabled(true)

    if (defaultAdd) {
      dropHandler(this.graph, null, null, 70, 100)
    }
  })
}

// 绑定事件
ApisEditor.prototype.bindKeyAction = function() {
  var self = this
  this.keyHandler.bindKey(46, function() {
    // Delete
    self.deleteSelectCells()
  })
  this.keyHandler.bindControlKey(90, function() {
    // Ctrl+Z
    self.execute('undo')
  })
  this.keyHandler.bindControlKey(89, function() {
    // Ctrl+Y
    self.execute('redo')
  })
  this.keyHandler.bindControlKey(88, function() {
    // Ctrl+X
    self.execute('cut')
  })
  this.keyHandler.bindControlKey(67, function() {
    // Ctrl+C
    self.executeCopy()
  })
  this.keyHandler.bindControlKey(65, function() {
    // Ctrl+A
    self.execute('selectAll')
  })
}

// 配置样式
ApisEditor.prototype.configureStylesheet = function() {
  var style = {}
  style = this.graph.getStylesheet().getDefaultEdgeStyle()
  style[MxConstants.STYLE_EDGE] = MxConstants.EDGESTYLE_ORTHOGONAL
  style[MxConstants.STYLE_STROKECOLOR] = '#999'
  style[MxConstants.STYLE_STROKEWIDTH] = '2'
  style = this.graph.getStylesheet().getDefaultVertexStyle()
  style[MxConstants.STYLE_STROKECOLOR] = 'black'
  style[MxConstants.STYLE_FONTSIZE] = 12
  this.graph.alternateEdgeStyle = 'elbow=vertical'
}

// 高亮显示
ApisEditor.prototype.highlight = function() {
  var self = this
  var highlightList = []
  var highlighEdgetList = []

  // 给图中节点加入单击事件
  this.graph.addListener(MxEvent.CLICK, function(sender, evt) {
    var cell = evt.getProperty('cell')

    // 高亮节点集合
    if (highlightList) {
      for (var k = 0; k < highlightList.length; k++) {
        highlightList[k].light.destroy()
      }
    }

    // 高亮线集合
    if (highlighEdgetList) {
      for (var h = 0; h < highlighEdgetList.length; h++) {
        highlighEdgetList[h].light.destroy()
      }
    }

    if (cell && cell.isVertex) {
      var edges = cell.edges
      if (!cell.edges) return

      for (var i = 0; i < edges.length; i++) {
        var edge = edges[i]
        var highlight = null
        var highlightMap = null
        var highlightEdge = null
        var highlightEdgeMap = null
        // console.log('highlight cell==', cell)

        // 添加上级节点相关高亮配置
        if (cell.id !== edge.source.id) {
          var cellSource = self.graph.getModel().getCell(edge.source.id)
          // 上级节点高亮配置
          highlight = new MxCellHighlight(self.graph, '#00FF00', 2)
          highlight.highlight(self.graph.view.getState(cellSource))
          highlightMap = {}

          highlightMap.cell = cellSource
          highlightMap.light = highlight
          highlightList.push(highlightMap)

          // 上级连线高亮配置
          highlightEdge = new MxCellHighlight(self.graph, '#00FF00', 2)
          highlightEdge.highlight(self.graph.view.getState(edge))
          highlightEdgeMap = {}
          highlightEdgeMap.light = highlightEdge
          highlighEdgetList.push(highlightEdgeMap)
        }

        // 添加下级节点相关高亮配置
        if (edge.target && cell.id !== edge.target.id) {
          var cellTarget = self.graph.getModel().getCell(edge.target.id)
          // 下级节点高亮配置
          highlight = new MxCellHighlight(self.graph, '#00FF00', 2)
          highlight.highlight(self.graph.view.getState(cellTarget))

          highlightMap = {}
          highlightMap.cell = cellTarget
          highlightMap.light = highlight
          highlightList.push(highlightMap)
          // 下级连线高亮配置
          highlightEdge = new MxCellHighlight(self.graph, '#00FF00', 2)
          highlightEdge.highlight(self.graph.view.getState(edge))
          highlightEdgeMap = {}
          highlightEdgeMap.light = highlightEdge
          highlighEdgetList.push(highlightEdgeMap)
        }
      }
    }
  })
}

// 删除cell
ApisEditor.prototype.deleteSelectCells = function() {
  var cells = this.graph.getDeletableCells(this.graph.getSelectionCells())
  var deleteable = cells.some((item) => {
    return item.value !== 'begin'
  })
  if (deleteable) this.graph.removeCells(null, true)
}

// 选中事件
ApisEditor.prototype.onSelectedCell = function(sender, evt) {
  this.selectedCellListener(this.getSelectedCell())
}

// 获取选中
ApisEditor.prototype.getSelectedCell = function() {
  return this.graph.getSelectionCell() || this.graph.getModel().getRoot()
}

// execute方法扩展
ApisEditor.prototype.execute = function(action) {
  if (action === 'copy') {
    this.executeCopy()
  } else {
    this.editor.execute(action)
  }
}

// copy扩展
ApisEditor.prototype.executeCopy = function() {
  this.editor.execute('copy')
  var cells = this.graph.getSelectionCells()
  if (cells && cells.length > 0) {
    var copyText = document.createElement('textarea')
    copyText.style = 'position:absolute;left:-99999999px'
    document.body.appendChild(copyText)
    copyText.innerHTML = MxUtils.getPrettyXml(new MxCodec().encode(cells))
    copyText.readOnly = false
    copyText.select()
    copyText.setSelectionRange(0, copyText.value.length)
    document.execCommand('copy')
    document.body.removeChild(copyText)
  }
}

// 验证
ApisEditor.prototype.valid = function() {
  var cells = this.graph.getModel().cells
  for (var key in cells) {
    var cell = cells[key]
    if (cell && cell.edge) {
      if (cell.source == null || cell.target == null) {
        return cell
      }
    }
  }
  return null
}

// 设置xml
ApisEditor.prototype.setXML = function(xml) {
  var doc = MxUtils.parseXml(xml)
  var root = doc.documentElement
  var dec = new MxCodec(root.ownerDocument)
  dec.decode(root, this.graph.getModel())
  // this.selectedCellListener(this.getSelectedCell())
}

// 获取xml
ApisEditor.prototype.getXML = function() {
  return MxUtils.getPrettyXml(
    new MxCodec(MxUtils.createXmlDocument()).encode(this.graph.getModel())
  )
}

// 获取所有的可见mxcell
ApisEditor.prototype.getAllCell = function() {
  return this.graph.getModel().getRoot().children[0]['children'] || []
}

// 生成id
ApisEditor.prototype.setId = function(prefix = 'edge') {
  return prefix + '-' + Date.now() + Math.ceil(Math.random() * 99999)
}

// 实现value相同，index自增
ApisEditor.prototype.getIndex = function(value) {
  let list = this.parseXml2Json('vertex')
  let index = -1
  list.forEach((item) => {
    if (item.value === value) {
      index++
    }
  })
  return index
}

// 设置index
ApisEditor.prototype.setIndex = function(value, index) {
  var cells = this.graph.getModel().cells
  var list = Object.values(cells)
  list.forEach((item) => {
    if (item.value === value) {
      item.index = index > item.index ? item.index : item.index - 1
      this.update(item)
    }
  })
}

// xml转为json
ApisEditor.prototype.parseXml2Json = function(type = '') {
  var jsonObj = new Xml2Json().xmlstr2json(this.getXML())
  var jsonArr = jsonObj.mxGraphModel.root.mxCell || []
  var arr = []
  if (type === 'edge') {
    arr = jsonArr.filter((item) => {
      return item.edge
    })
  } else if (type === 'vertex') {
    arr = jsonArr.filter((item) => {
      return item.vertex
    })
  } else {
    arr = jsonArr.filter((item) => {
      return item.edge || item.vertex
    })
  }
  return arr
}

// 获取线
ApisEditor.prototype.getLine = function() {
  var vertexs = this.parseXml2Json('vertex')
  var lines = this.parseXml2Json('edge')
  var list = []
  lines.forEach((item) => {
    list.push({
      source: item.source,
      sourceType: getValue(item.source, 'value'),
      target: item.target,
      targetType: getValue(item.target, 'value')
    })
  })
  return list

  function getValue(val, type) {
    var cell = vertexs.filter((item) => {
      return item.id === val
    })
    return cell && cell[0] ? cell[0][type] : ''
  }
}

// 更新
ApisEditor.prototype.update = function(cell) {
  this.graph.getModel().beginUpdate()
  try {
    this.graph.refresh(cell)
  } finally {
    this.graph.getModel().endUpdate()
  }
}
